
import { MapWaypoint } from '../../core/models/mapping';
import { PathWaypoint } from '../../core/models/path-waypoint';
import { Point } from '../../core/models/point';
import { VolunteerTaskPointViewRecord} from '../models/volunteer-task-point-record';

export class VolunteerTaskMapPoint extends MapWaypoint {

    constructor( pathWaypoint: PathWaypoint, point: Point, public taskPoint: VolunteerTaskPointViewRecord ) {
        super(pathWaypoint,point)
    }
}